var map = {
	"./Cart.vue": "2c83",
	"./Item.vue": "1ce7",
	"./ItemModal.vue": "f741",
	"./SameCategoryItems.vue": "07f3",
	"./credits/CreditModal.vue": "b0b9",
	"./credits/CreditsHistory.vue": "8615",
	"./credits/Index.vue": "0373",
	"./credits/SendCredits.vue": "20b1",
	"./feedback/EmojiFeedback.vue": "059a",
	"./feedback/TextFeedback.vue": "61fb",
	"./feedback/UploadFeedback.vue": "a2f8",
	"./headers/CategoryHeader.vue": "8b2c",
	"./headers/LanguageSwitcher.vue": "59e7",
	"./headers/SearchHeader.vue": "c09d",
	"./headers/SearchWithSuggestionHeader.vue": "0a39",
	"./headers/SubCategoryHeader.vue": "c751",
	"./headers/UserModule.vue": "0d84",
	"./item/ItemDetails.vue": "c357",
	"./menu/Index.vue": "de2f",
	"./menu/Index_old.vue": "5946",
	"./menu/MenuModal.vue": "aae5",
	"./menu/ScreenIndex.vue": "20c1",
	"./mobile/Index.vue": "58a2",
	"./order/BusinessCard.vue": "77e8",
	"./order/BuyNowModal.vue": "18b8",
	"./order/CheckoutModal.vue": "84c3",
	"./order/OrderFilter.vue": "ff48",
	"./order/OrderList.vue": "92c4",
	"./order/OrderModal.vue": "689d",
	"./order/Profile.vue": "65e2",
	"./search/CoreSearch.vue": "019e",
	"./search/Index.vue": "a295",
	"./search/MapIndex.vue": "a368",
	"./search/Switcher.vue": "a0e8",
	"./user/LoginModal.vue": "b2af",
	"./user/RegisterModal.vue": "ac84",
	"./user/UserDropdown.vue": "0d6c",
	"./user/UserProfile/UserProfileGadgetsList.vue": "d496",
	"./user/UserProfile/userModules/Addresses.vue": "ee64",
	"./user/UserProfile/userModules/Favorites.vue": "201f",
	"./user/UserProfile/userModules/Information.vue": "2fff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c3d";